import React, { useState } from "react";
import { Box, TextField, Button, Typography, CircularProgress, IconButton, InputAdornment } from "@mui/material";
import axiosInstance from "../axiosInstance";
import { toast } from "react-toastify";
import { FaKey } from "react-icons/fa"; // Icon for generate password
const apiUrl = process.env.REACT_APP_API_URL;

const VendorAdd = () => {
  const [vendorId, setVendorId] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    vendorId: "",
    username: "",
    email: "",
    password: "",
    api: "",
  });
  const [loading, setLoading] = useState(false);

  // Function to generate a random 10-character password
  const generatePassword = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let generatedPassword = "";
    for (let i = 0; i < 10; i++) {
      generatedPassword += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setPassword(generatedPassword);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ vendorId: "", username: "", email: "", password: "", api: "" }); // Reset errors
  
    // Simple validation
    if (!vendorId || !username || !email || !password) {
      setErrors((prev) => ({
        ...prev,
        vendorId: !vendorId ? "Vendor ID is required" : "",
        username: !username ? "Username is required" : "",
        email: !email ? "Email is required" : "",
        password: !password ? "Password is required" : "",
      }));
      return;
    }
  
    try {
      setLoading(true);
  
      const token = localStorage.getItem("authToken");
  
      if (!token) {
        navigate("/login", { replace: true }); // Redirect if no token
        return;
      }
  
      // Use POST request instead of GET and send payload correctly
      await axiosInstance.post(
        `${apiUrl}/vendor/add`,
        { vendorId, username, email, password }, // Request payload
        { headers: { Authorization: `Bearer ${token}` } } // Headers
      );
  
      // Handle success
      toast.success("Registration successful!");
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Registration failed");
      } else {
        toast.error("An unexpected error occurred");
      }
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ bgcolor: "#f7f7f7", p: 3 }}
    >
      <Typography variant="h4" gutterBottom>
        Vendor Register
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Vendor ID"
          variant="outlined"
          margin="normal"
          fullWidth
          value={vendorId}
          onChange={(e) => setVendorId(e.target.value)}
          error={Boolean(errors.vendorId)}
          helperText={errors.vendorId}
        />
        <TextField
          label="Username"
          variant="outlined"
          margin="normal"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          error={Boolean(errors.username)}
          helperText={errors.username}
        />
        <TextField
          label="Email"
          variant="outlined"
          margin="normal"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
        <TextField
          label="Password"
          type="text"
          variant="outlined"
          margin="normal"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={Boolean(errors.password)}
          helperText={errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={generatePassword} edge="end">
                  <FaKey />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Register"}
        </Button>
      </form>
    </Box>
  );
};

export default VendorAdd;
